import { render, staticRenderFns } from "./CreateBlueCard.vue?vue&type=template&id=147f9e14&scoped=true&"
import script from "./CreateBlueCard.vue?vue&type=script&lang=js&"
export * from "./CreateBlueCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateBlueCard.vue?vue&type=style&index=0&id=147f9e14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147f9e14",
  null
  
)

export default component.exports